// 万元现金大奖
import vipService from '@api/vipConfig'

// 获取活动信息
export const getInfo = (data) => {
  return vipService.request({
    url: `/drawtenthousand/info`,
    method: 'post',
    data: data
  })
}

// 获取昨日中奖名单
export const getWinList = (data) => {
  return vipService.request({
    url: `/drawtenthousand/win`,
    method: 'post',
    data: data
  })
}

// 报名
export const sign = (data) => {
  return vipService.request({
    url: `/drawtenthousand/sign`,
    method: 'post',
    data: data
  })
}

// 我的中奖记录
export const myWins = (data) => {
  return vipService.request({
    url: `/drawtenthousand/my/wins`,
    method: 'post',
    data: data
  })
}
